import { type FC, type ReactNode } from 'react'
import { Link } from 'react-router-dom'

interface SidebarNavLinkProps {
  to: string
  label: string
  icon: ReactNode
  isActive: boolean
  isSidebarOpen: boolean
  /** The main navigation, or the bottom section above the profile menu. */
  placement: 'nav' | 'bottom'
  testId: string
}

/** One sidebar link: the active state for the current page, and the label as a tooltip while collapsed. */
export const SidebarNavLink: FC<SidebarNavLinkProps> = ({
  to,
  label,
  icon,
  isActive,
  isSidebarOpen,
  placement,
  testId,
}) => {
  const itemClass = placement === 'nav' ? 'sidebar__nav-item' : 'sidebar__bottom-item'
  return (
    <Link
      to={to}
      className={`${itemClass} ${isActive ? `${itemClass}--active` : ''}`}
      aria-current={isActive ? 'page' : undefined}
      title={!isSidebarOpen ? label : ''}
      data-testid={testId}
    >
      {icon}
      <span className="sidebar__nav-label">{label}</span>
    </Link>
  )
}
